import { useApiQuery } from "./use-api-query.ts";

export function useBranches() {
  return useApiQuery<string[]>("/runs/branches", {
    staleTime: 60 * 1000, // Cache for 1 minute
  });
}
